import { render, staticRenderFns } from "./PlatformTransferConfirm.vue?vue&type=template&id=49d5ce5b&"
import script from "./PlatformTransferConfirm.vue?vue&type=script&lang=js&"
export * from "./PlatformTransferConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports